
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as authnsElNSNj_rLQlIWUIay965JlFLujs_lJYGW9xdWJ0nkMeta } from "/src/app/pages/auth.vue?macro=true";
import { default as homeGucZrzP0_QKj87xJzPe0gV4vRjlFZdkUP7_BIcbMLoUMeta } from "/src/app/pages/home.vue?macro=true";
import { default as locationsYeEC9j3D3_UW4EiOSLzdIUdgPYh5v0IUPr_ohIMrHpcMeta } from "/src/app/pages/locations.vue?macro=true";
import { default as menu43nW_r3U4K__YZWqWf2IhkOGaaoLLHIPtwHw1edRatEMeta } from "/src/app/pages/ordering/menu.vue?macro=true";
import { default as order_45trackingL2lI2LE_zHCbKCkv4hFxxMNXbFaPaAHt4QEQ0Ltkyk0Meta } from "/src/app/pages/order-tracking.vue?macro=true";
import { default as loyalty_45programpYOATZO_0gBg2882Fptq9eNx_memHfhfjhWYoVP_0gEMeta } from "/src/app/pages/loyalty-program.vue?macro=true";
import { default as profilegreHDS8hKTUNZvK2Vix20xbuyCE1A9yiUEogX7L_EkcMeta } from "/src/app/pages/my-account/profile.vue?macro=true";
import { default as indexsXBCPBNTYw17fnSyS_f0C2IcUQVNUt8nzzArp5ejKPcMeta } from "/src/app/pages/ordering/menus/index.ts?macro=true";
import { default as addressesmjGjmMxKhAkPyLrbfT7V18eAufCP_xFgyKqFscMl5uAMeta } from "/src/app/pages/my-account/addresses.vue?macro=true";
import { default as Menus1p01_PR2wpnWg0PpushKuMGyws1CtQqqx_vpkZBlUI8Meta } from "/src/app/pages/ordering/menus/Menus.vue?macro=true";
import { default as indexpIccZsvBZAg52s_dxSibQDjNqVTjb_0aDu_d2_B6uUYMeta } from "/src/app/pages/ordering/outlet/index.ts?macro=true";
import { default as select_45mode9bVPPNE2H4Jnv2bY5iclXlUTes43AR3Zi1q5hMU3SBAMeta } from "/src/app/pages/ordering/select-mode.vue?macro=true";
import { default as my_45account_o2LZOiCMb1uGkZfV1HbzspUlw9twz8bVDjdQhesgJcMeta } from "/src/app/pages/my-account/my-account.vue?macro=true";
import { default as indexgtdNX1CTGweyoHfGTO__EYAYnZfV9JtrBWY_9grACUgMeta } from "/src/app/pages/ordering/checkout/index.ts?macro=true";
import { default as OutletwNHBgThfx9WoDyzO21p3AH8HR6oJscAnouVH4Kjf7AwMeta } from "/src/app/pages/ordering/outlet/Outlet.vue?macro=true";
import { default as order_45historyNVQ7O7DLtFM4XQn_yQJkKPOzyGOcSci4VDO3DBFMeZYMeta } from "/src/app/pages/my-account/order-history.vue?macro=true";
import { default as CheckoutuEDIVFUf75fp_dRH_OJzkTAEmTFmWdhAeSpE6HYzZacMeta } from "/src/app/pages/ordering/checkout/Checkout.vue?macro=true";
import { default as usePluLoyaltyXmNkxRDd1dV_SoHWlNgfNMSOETM0cMMSkVA3ZgRAQY4Meta } from "/src/app/pages/ordering/outlet/usePluLoyalty.ts?macro=true";
export default [
  {
    name: "auth",
    path: "/auth",
    component: () => import("/src/app/pages/auth.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/src/app/pages/home.vue")
  },
  {
    name: "locations",
    path: "/locations",
    component: () => import("/src/app/pages/locations.vue")
  },
  {
    name: "ordering-menu",
    path: "/ordering/menu",
    component: () => import("/src/app/pages/ordering/menu.vue")
  },
  {
    name: "order-tracking",
    path: "/order-tracking",
    component: () => import("/src/app/pages/order-tracking.vue")
  },
  {
    name: "loyalty-program",
    path: "/loyalty-program",
    component: () => import("/src/app/pages/loyalty-program.vue")
  },
  {
    name: "my-account-profile",
    path: "/my-account/profile",
    component: () => import("/src/app/pages/my-account/profile.vue")
  },
  {
    name: "ordering-menus",
    path: "/ordering/menus",
    component: () => import("/src/app/pages/ordering/menus/index.ts")
  },
  {
    name: "my-account-addresses",
    path: "/my-account/addresses",
    component: () => import("/src/app/pages/my-account/addresses.vue")
  },
  {
    name: "ordering-menus-Menus",
    path: "/ordering/menus/Menus",
    component: () => import("/src/app/pages/ordering/menus/Menus.vue")
  },
  {
    name: "ordering-outlet",
    path: "/ordering/outlet",
    component: () => import("/src/app/pages/ordering/outlet/index.ts")
  },
  {
    name: "ordering-select-mode",
    path: "/ordering/select-mode",
    component: () => import("/src/app/pages/ordering/select-mode.vue")
  },
  {
    name: "my-account-my-account",
    path: "/my-account/my-account",
    component: () => import("/src/app/pages/my-account/my-account.vue")
  },
  {
    name: "ordering-checkout",
    path: "/ordering/checkout",
    component: () => import("/src/app/pages/ordering/checkout/index.ts")
  },
  {
    name: "ordering-outlet-Outlet",
    path: "/ordering/outlet/Outlet",
    component: () => import("/src/app/pages/ordering/outlet/Outlet.vue")
  },
  {
    name: "my-account-order-history",
    path: "/my-account/order-history",
    component: () => import("/src/app/pages/my-account/order-history.vue")
  },
  {
    name: "ordering-checkout-Checkout",
    path: "/ordering/checkout/Checkout",
    component: () => import("/src/app/pages/ordering/checkout/Checkout.vue")
  },
  {
    name: "ordering-outlet-usePluLoyalty",
    path: "/ordering/outlet/usePluLoyalty",
    component: () => import("/src/app/pages/ordering/outlet/usePluLoyalty.ts")
  }
]